export enum ApiCustomErrorCode{
  AUTENTIFICACION = -1,
  PERMISOS = -2
}
